import type { TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthorBasicInfo } from './tweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthorBasicInfo';
import type { TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthorSocial } from './tweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthorSocial;
};
